<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-expansion-panels  accordion multiple>
      <v-expansion-panel key="0" class="whitesmoke" >
        <v-expansion-panel-header>
          <div>
            <v-icon color="text-color" class="mr-3">mdi-water-boiler</v-icon>
            <span>{{ $t("boiler_control") }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content >
          <v-row v-if="device.data.properties.ot.domx !== undefined" class="whitesmoke" no-gutters>
            <DeviceOverviewSwitchCard
              v-if="device.data.properties.ot.domx.heat_set !== undefined"
              :value="device.data.properties.ot.domx.heat_set == 1 ? true : false"
              :title_number="$t('heating_control')"
              :subTitle="$t('heating_control_subtitle')"
              text_font_size="18px"
              control="heating_control"
              @heatingControlValChange="heatingControlChange"
            >
            </DeviceOverviewSwitchCard>
            <DeviceOverviewSwitchCard
              v-if="device.data.properties.ot.domx.water_set !== undefined"
              :value="device.data.properties.ot.domx.water_set == 1 ? true : false"
              :title_number="$t('hot_water_control')"
              :subTitle="$t('hot_water_control_subtitle')"
              text_font_size="18px"
              control="hot_water_control"
              @hotWaterControlValChange="hotWaterControlChange"
            >
            </DeviceOverviewSwitchCard>
            <DeviceOverviewSwitchCard
              v-if="device.data.properties.ot.domx.bypass !== undefined"
              :value="device.data.properties.ot.domx.bypass == 1 ? true : false"
              :title_number="$t('weather_adaptation')"
              :subTitle="$t('weather_adaptation_subtitle')"
              text_font_size="18px"
              control="weather_adaptation"
              @weatherAdaptationValChange="weatherAdaptationChange"
            >
            </DeviceOverviewSwitchCard>
            <DeviceOverviewSliderCard
              v-if="device.data.properties.ot.domx.cloud_blr !== undefined"
              v-model="device.data.properties.ot.domx.cloud_blr"
              :min="1"
              :max="100"
              :step="1"
              :decimals="0"
              :title_number="$t('fixed_boiler_temperature')"
              text_font_size="18px"
              :disabled="device.data.properties.ot.domx.bypass == 1 ? true : false"
              control="fixed_boiler_temperature"
              @fixedBoilerTemperatureValChange="fixedBoilerTemperatureChange"
            >
            </DeviceOverviewSliderCard>
            <DeviceOverviewSliderCard
              v-if="device.data.properties.ot.domx.t_dhw_set !== undefined"
              v-model="device.data.properties.ot.domx.t_dhw_set"
              :min="1"
              :max="100"
              :step="1"
              :decimals="0"
              :title_number="$t('max_hot_water_temperature')"
              text_font_size="18px"
              :disabled="false"
              control="max_hot_water_temperature"
              @maxHotWaterValChange="maxHotWaterChange"
            >
            </DeviceOverviewSliderCard>
            <DeviceOverviewButtonCard
              v-if="device.data.properties.ot.domx !== undefined"
              :title_number="$t('remote_reset')"
              text_font_size="18px"
              buttonMsg="reset_uppercase"
              @buttonPressed="deviceReset"
            ></DeviceOverviewButtonCard>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel key="1" class="whitesmoke" >
        <v-expansion-panel-header>
          <div>
            <v-icon color="text-color" class="mr-3">mdi-chart-bell-curve-cumulative</v-icon>
            <span>{{ $t("weather_adaptation_control") }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content >
          <v-row v-if="device.data.properties.ot.domx  !== undefined" class="whitesmoke " no-gutters>
            <DeviceOverviewHeatingBalanceSliderCard
              v-if="device.data.properties.ot.domx.otc_cur !== undefined"
              v-model="device.data.properties.ot.domx.otc_cur"
              :min="1"
              :max="10"
              :title_number="$t('heating_balance')"
              text_font_size="18px"
              :disabled="device.data.properties.ot.domx.bypass != 1"
              @valChange="heatingBalanceChange"
            >
            </DeviceOverviewHeatingBalanceSliderCard>
            <DeviceOverviewSliderCard
              v-if="device.data.properties.ot.domx.ch_lb !== undefined"
              v-model="device.data.properties.ot.domx.ch_lb"
              :min="1"
              :max="100"
              :step="1"
              :decimals="0"
              :title_number="$t('weather_adaptation_lower_limit')"
              text_font_size="18px"
              :disabled="device.data.properties.ot.domx.bypass != 1"
              control="weather_adaptation_lower_limit"
              @weatherAdaptationLowerLimitValChange="
                weatherAdaptationLowerLimitChange
              "
            >
            </DeviceOverviewSliderCard>
            <DeviceOverviewSliderCard
              v-if="device.data.properties.ot.domx.ch_ub !== undefined"
              v-model="device.data.properties.ot.domx.ch_ub"
              :min="1"
              :max="100"
              :step="1"
              :decimals="0"
              :title_number="$t('weather_adaptation_upper_limit')"
              text_font_size="18px"
              :disabled="device.data.properties.ot.domx.bypass != 1"
              control="weather_adaptation_upper_limit"
              @weatherAdaptationUpperLimitValChange="
                weatherAdaptationUpperLimitChange
              "
            >
            </DeviceOverviewSliderCard>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel key="2" class="whitesmoke" >
        <v-expansion-panel-header>
          <div>
            <v-icon color="text-color" class="mr-3">mdi-home-thermometer-outline</v-icon>
            <span>{{ $t("temperature_control") }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content >
          <v-row v-if="device.data.properties.ot.domx !== undefined" class="whitesmoke " no-gutters>
            <DeviceOverviewRoomTargetCard
              v-if="device.data.properties.ot.domx.t_r_set !== undefined"
              :title_number="$t('room_target')"
              text_font_size="18px"
              cols=6
              :val="device.data.properties.ot.domx.t_r_set"
              :indoor="device.data.properties.ot.domx.t_r"
              :min="device.data.properties.ot.domx.t_r_set_min"
              :max="device.data.properties.ot.domx.t_r_set_max"
              :step="0.5"
              @roomTargetValChange="roomTargetChange"
            >
            </DeviceOverviewRoomTargetCard>
            <DeviceOverviewRoomTargetLimitsCard
              v-if="device.data.properties.ot.domx.t_r_set !== undefined"
              cols=6
              :title_number="$t('temperatureRangeLimits')"
              :subTitle="$t('temperatureRangeLimitsSubtitle')"
              text_font_size="18px"
              :val="device.data.properties.ot.domx.t_r_set_min + ','+ device.data.properties.ot.domx.t_r_set_max"
              :indoor="device.data.properties.ot.domx.t_r"
              :min="5"
              :max="35"
              :step="0.5"
              @roomLowerLimitValChange="roomLowerLimitSet"
              @roomUpperLimitValChange="roomUpperLimitSet"
            >
            </DeviceOverviewRoomTargetLimitsCard>
            <DeviceOverviewButtonCard
              v-if="device.data.properties.ot.domx !== undefined"
              :title_number="$t('remote_pair')"
              :subTitle="$t('pair_thermostat_subtitle')"
              cols="6"
              loaderSecs=30 
              buttonMsg="pair_uppercase"
              text_font_size="18px"
              @buttonPressed="rfModulePair"
            ></DeviceOverviewButtonCard>
            <DeviceOverviewButtonCard
              v-if="device.data.properties.ot?.rf?.t_r_ofst !== undefined"
              :title_number="$t('reset_thermostat_offset')"
              :subTitle="$t('current_value') + ': ' + device.data.properties.ot.rf?.t_r_ofst"
              cols="6"
              buttonMsg="reset_uppercase"
              text_font_size="18px"
              @buttonPressed="resetThermostatOffset"
            ></DeviceOverviewButtonCard>
            <DeviceOverviewSwitchCard
            v-if="device.data.properties.ot?.rf?.chl_lck !== undefined"
              :value="device.data.properties.ot.rf?.chl_lck == 1 ? true : false"
              :title_number="$t('chl_lck')"
              :subTitle="$t('chl_lck_subtitle')"
              text_font_size="18px"
              cols="6"
              control="lock_thermostat"
              @lockThermostatValChange="childLockControlChange"
            />
            <DeviceOverviewSwitchCard
              v-if="device.data.properties.ot.domx.t_r_overr !== undefined"
              :value="device.data.properties.ot.domx.t_r_overr == 1 ? true : false"
              :title_number="$t('lock_wired_thermostat')"
              :subTitle="$t('lock_wired_thermostat_subtitle') + ' - ' + $t('current_thermostat_value') + ': ' + (device.data.properties.ot.thermostat.state ? 'ON' : 'OFF') "
              text_font_size="18px"
              cols="6"
              control="lock_thermostat"
              @lockThermostatValChange="wiredThermostatLockControlChange"
            />
            <DeviceOverviewSwitchCard
              v-if="device.data.properties.ot.domx.rf_failsafe !== undefined"
              :value="device.data.properties.ot.domx.rf_failsafe == 1 ? true : false"
              :title_number="$t('rf_failsafe')"
              :subTitle="$t('rf_failsafe_subtitle')"
              text_font_size="18px"
              cols="6"
              control="lock_thermostat"
              @lockThermostatValChange="rfFailsafeControlChange"
            />
            <DeviceOverviewSwitchCard
              v-if="device.data.properties.ot.domx.db_en !== undefined"
              :value="device.data.properties.ot.domx.db_en == 1 ? true : false"
              :title_number="$t('db_en')"
              :subTitle="$t('db_en_subtitle')"
              text_font_size="18px"
              cols="6"
              control="db_en"
              @deadbandEnable="deadbandEnableControlChange"
            />
            <DeviceOverviewSliderCard
              v-if="device.data.properties.ot.domx.db !== undefined"
              v-model="device.data.properties.ot.domx.db"
              :min="0.2"
              :max="6"
              :step="0.1"
              :decimals="1"
              cols=6
              :title_number="$t('db')"
              :subTitle="$t('db_subtitle')"
              text_font_size="18px"
              :disabled="device.data.properties.ot.domx.db_en == 0 ? true : false"
              control="db"
              @setDeadband="deadbandControlChange"
            />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
  </v-expansion-panels>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import DashboardCardBarChart from "@/components/Cards/DashboardCardBarChart.vue";
import DashboardCardPieChart from "@/components/Cards/DashboardCardPieChart.vue";
import DeviceOverviewCard from "@/components/Cards/DeviceOverviewCard.vue";
import DeviceOverviewSwitchCard from "@/components/Cards/DeviceOverviewSwitchCard.vue";
import DeviceOverviewButtonCard from "@/components/Cards/DeviceOverviewButtonCard.vue";
import DeviceOverviewHeatingBalanceSliderCard from "@/components/Cards/DeviceOverviewHeatingBalanceSliderCard.vue";
import DeviceOverviewSliderCard from "@/components/Cards/DeviceOverviewSliderCard.vue";
import DashboardCardFaultsPieChart from "@/components/Cards/DashboardCardFaultsPieChart.vue";
import DeviceOverviewRoomTargetCard from "@/components/Cards/DeviceOverviewRoomTargetCard.vue";
import DeviceOverviewRoomTargetLimitsCard from "@/components/Cards/DeviceOverviewRoomTargetLimitsCard.vue";
import { devicesModule } from '@/store/modules/store-accessor'

@Component({
  components: {
    DashboardCardBarChart,
    DashboardCardPieChart,
    DeviceOverviewCard,
    DeviceOverviewSwitchCard,
    DeviceOverviewButtonCard,
    DeviceOverviewHeatingBalanceSliderCard,
    DeviceOverviewSliderCard,
    DeviceOverviewRoomTargetCard,
    DeviceOverviewRoomTargetLimitsCard,
    DashboardCardFaultsPieChart,
  }
})

export default class HeatingControllerControlView
 extends Vue {
  @Prop() device: Record<string, any>;


  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  weatherAdaptationUpperLimitChange(val: string): void {
    let data = {
        action: "ch_ub",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  heatingControlChange(val: string) : void {
    let data = {
        action: "heat_set",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  childLockControlChange(val: string) : void {
    let data = {
        action: "chl_lck",
        action_value: val ? 1 : 0
    }
    devicesModule.updateDeviceConfig(data);
  }

  wiredThermostatLockControlChange(val: string) : void {
    let data = {
        action: "t_r_overr",
        action_value: val ? 1 : 0
    }
    devicesModule.updateDeviceConfig(data);
  }


  rfFailsafeControlChange(val: string) : void {
    let data = {
        action: "rf_failsafe",
        action_value: val ? 1 : 0
    }
    devicesModule.updateDeviceConfig(data);
  }

  deadbandEnableControlChange(val: string) : void {
    let data = {
        action: "db_en",
        action_value: val ? 1 : 0
    }
    devicesModule.updateDeviceConfig(data);
  }

  deadbandControlChange(val: string) : void {
    let data = {
        action: "db",
        action_value: val
    }
    devicesModule.updateDeviceConfig(data);
  }

  hotWaterControlChange(val: string) : void {
    let data = {
        action: "water_set",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  weatherAdaptationChange(val: boolean) : void {
    let data = {
       action: "bypass",
       action_value: val ? 1 : 2
    }
    devicesModule.updateDeviceConfig(data);
  }

  maxHotWaterChange(val: string) : void {
    let data = {
        action: "t_dhw_set",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  fixedBoilerTemperatureChange(val: string) : void {
    let data = {
        action: "t_set",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  heatingBalanceChange(val: string) : void {
    let data = {
        action: "otc_cur",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  weatherAdaptationLowerLimitChange(val: string): void {
    let data = {
        action: "ch_lb",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  deviceReset(val: boolean): void {
    let data = {
        action: "remote_reset",
        action_value: true,
    }
    devicesModule.updateDeviceConfig(data);
  }

  rfModulePair(val: boolean): void {
    let data = {
        action: "pair_rf_thermostat",
        action_value: true,
    }
    devicesModule.updateDeviceConfig(data);
  }

  resetThermostatOffset(val: boolean): void {
    let data = {
        action: "t_r_ofst",
        action_value: 0,
    }
    devicesModule.updateDeviceConfig(data);
  }

  roomTargetChange(val: number): void {
    let data = {
        action: "t_r_set",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  roomLowerLimitSet(val: number): void {
    let data = {
        action: "t_r_set_min",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }

  roomUpperLimitSet(val: number): void {
    let data = {
        action: "t_r_set_max",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }
};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh - 230px) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
